import React, { useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import { removeFailedImportBookId } from '../../../redux/actions';
import { CircularProgress, IconButton, Tooltip, Typography } from "@material-ui/core";
import { CheckCircle, CloudDownload, Refresh } from "@material-ui/icons";
import scheduledDownloadImage from '../../../assets/ScreenShots/scheduled_download.png';



const Download = (props) => {
  const { 
    checked, 
    loading, 
    onDownload, 
    loadingComponent, 
    downloadAriaLabel, 
    isBookShare=false,
    bookId,
    failedImportBookIds = []
  } = props;

  const dispatch = useDispatch();

  const hasFailedImport = failedImportBookIds.includes(bookId);
  const [showRetryIcon, setShowRetryIcon] = useState(false);

  useEffect(() => {
    let timer;
    if (hasFailedImport) {
      setShowRetryIcon(false);
      timer = setTimeout(() => setShowRetryIcon(true), 4000);
    } else {
      setShowRetryIcon(false);
    }
    return () => { if (timer) clearTimeout(timer); };
  }, [hasFailedImport]);

  const handleRetry = (e) => {
    // Clear the error state before attempting retry
    if (failedImportBookIds.includes(bookId)) {
      dispatch(removeFailedImportBookId(bookId));
    }
    
    // Attempt the download again
    onDownload(e);
  };

  if (hasFailedImport) {
    return (
      <Tooltip title="Import failed. Click to try again.">
        <IconButton 
          onClick={(e) => handleRetry(e)}
        >
          {showRetryIcon ? (
            <Refresh style={{ color: 'red' }} />
          ) : (
            <Typography style={{ color: 'red', fontSize: '14px' }}>
              Error
            </Typography>
          )}
        </IconButton>
      </Tooltip>
    );
  }

  if (checked) {
    return (
      <>
      {isBookShare ? (
        <Tooltip title="Ready in 24-48 hours">
          <span style={{color: "green", fontStyle: "italic"}}>Requested</span>
        </Tooltip>
      ) : (
        <CheckCircle />
      )}
    </>
    );
  }

  if (loading) {
    if (loadingComponent) {
      return loadingComponent;
    }
    return (
      <IconButton>
        <CircularProgress size={24} />
      </IconButton>
    )
  }
  return (
    <IconButton aria-label={downloadAriaLabel} onClick={onDownload}>
      {isBookShare ? (
        <Tooltip title="Request from Bookshare (24-48 hours)">
          <img src={scheduledDownloadImage} height={"50px"} width={"50px"} />
        </Tooltip>
      ) : (
        <CloudDownload />
      )}
    </IconButton>
  );
};

export default Download;
